import { render } from "./McpServerCarouselCard.vue?vue&type=template&id=2fb23963&scoped=true&ts=true"
import script from "./McpServerCarouselCard.vue?vue&type=script&lang=ts"
export * from "./McpServerCarouselCard.vue?vue&type=script&lang=ts"

import "./McpServerCarouselCard.vue?vue&type=style&index=0&id=2fb23963&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb23963"]])

export default __exports__